import { delRole, getRole } from "./permission";

interface LoginInfo {
    id: string;
    token: string;
    account: string;
}

export function getUserId(): string {
    const userId = localStorage.getItem("userId");
    if (!userId) {
        return "";
    }
    return userId;
}

export function getUserName(): string {
    const userId = localStorage.getItem("userId");
    if (!userId) {
        return "";
    }
    const userName = localStorage.getItem("user-" + String(userId) + "name");
    if (userName) {
        return userName;
    }
    return "";
}

export function getToken(): string {
    const userId = localStorage.getItem("userId");
    if (!userId) {
        return "";
    }
    const token = localStorage.getItem("user-" + String(userId) + "-token");
    if (token) {
        return token;
    }
    return "";
}

export function setLoginInfo(data: LoginInfo): void {
    localStorage.setItem("userId", data.id);
    localStorage.setItem(
        "user-" + String(data.id) + "-token",
        data.token
    );
    localStorage.setItem("user-" + String(data.id) + "-name",
        data.account
    );
}

export function cleanLoginInfo(): void {
    const userId = localStorage.getItem("userId");
    if (!userId) {
        return;
    }
    localStorage.removeItem("userId");
    localStorage.removeItem("user-" + String(userId));
    delRole(userId);
}

export function checkPermission(permission: string): boolean {
    if (permission === getRole(getUserId())) {
        return true;
    }
    return false;
}